import { DeviceCategoryEnum, IfcClassesEnum } from "./deviceCategoryConfig";
export const getDeeplyNestedValue = (obj, path) => {
    const keys = path.split(".");
    const result = keys.reduce((acc, key) => {
        if (acc == null || typeof acc !== "object") {
            return undefined;
        }
        return acc[key];
    }, obj);
    return typeof result === "string" || typeof result === "number" ? String(result) : undefined;
};
export const getMcbimItemClassificationInput = ({ mcbimItem, compCodePath, }) => {
    return {
        instanceClass: mcbimItem.instanceClass,
        name: mcbimItem.name,
        typeName: mcbimItem.type?.name,
        compCode: compCodePath ? getDeeplyNestedValue(mcbimItem, compCodePath) : undefined,
        isInCeiling: mcbimItem.psets?.NRH_PG_Info?.["I himling"] === true,
    };
};
export const getRoomMcBimItemClassificationInput = (roomMcBimItem) => {
    return {
        instanceClass: roomMcBimItem.instanceClass,
        name: roomMcBimItem.name,
        typeName: roomMcBimItem.typeName,
        compCode: roomMcBimItem.compCode,
        isInCeiling: null,
    };
};
export const isSupplyAirTerminal = (input) => {
    return (input.instanceClass === "IfcAirTerminal" && (input.compCode ?? "").startsWith("STA"));
};
export const isReturnAirterminal = (input) => {
    return (input.instanceClass === "IfcAirTerminal" && (input.compCode ?? "").startsWith("SF"));
};
export const isKvadradiskInfeldArmatur = (input) => {
    return input.instanceClass === "IfcLightFixture";
};
export const isChillerDevice = (input) => {
    const compCode = input.compCode ?? "";
    return (input.instanceClass === IfcClassesEnum.IFCCHILLER ||
        input.instanceClass === "IfcCooledBeam" ||
        compCode.startsWith("LDZ"));
};
export const isFireSuppression = (input) => {
    return (input.instanceClass === "IfcFireSuppressionTerminal" &&
        (input.typeName ?? "").toUpperCase().includes("HIMLING"));
};
export const isSensor = (input) => {
    return input.instanceClass === "IfcSensor";
};
export const sortMcBimItemsFurnituresFirst = (mcBimItems) => {
    return [...mcBimItems].sort((a, b) => {
        if (a.instanceClass === IfcClassesEnum.IFCFURNITURE) {
            return -1;
        }
        if (b.instanceClass === IfcClassesEnum.IFCFURNITURE) {
            return 1;
        }
        return 0;
    });
};
export const getDeviceCategoryForMcBimItem = (input) => {
    if (isSupplyAirTerminal(input)) {
        return DeviceCategoryEnum.SUPPLY_AIR_DEVICE;
    }
    if (isReturnAirterminal(input)) {
        return DeviceCategoryEnum.RETURN_AIR_DEVICE;
    }
    if (isKvadradiskInfeldArmatur(input)) {
        return DeviceCategoryEnum.LIGHT_DEVICE;
    }
    if (isFireSuppression(input)) {
        return DeviceCategoryEnum.FIRE_SUPPRESSION_DEVICE;
    }
    if (isSensor(input)) {
        return DeviceCategoryEnum.SENSOR_DEVICE;
    }
    if (isChillerDevice(input)) {
        return DeviceCategoryEnum.CHILLER;
    }
    if (input.instanceClass === IfcClassesEnum.IFCCHILLER) {
        return DeviceCategoryEnum.CHILLER;
    }
    return undefined;
};
